export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7352.6a3560c8.jpg";